export enum PollType {
  ACTUAL_POLL = 'Actual Poll',
  EXIT_POLL = 'Exit Poll'
}
